export const LIQUIDEZ_MARGINS_CHART_ID = '#chart-liquidez-margens'

export const LIQUIDEZ_ALVOS_CHART_ID = '#chart-liquidez-alvos'